// extracted by mini-css-extract-plugin
export default {"ffOverridesBanner":"OverridesBanner-styles__ffOverridesBanner___3YZAs","withLink":"OverridesBanner-styles__withLink___KMpCr"};